module.exports = __webpack_public_path__ + "static/ifood-logo-merchant-api-fea01063396cec32ce21901c59fa1547.svg";